<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="home" ref="headerRow"></HeaderRow>
				<div class="banner">
					<el-carousel v-if="bannerList&&bannerList.length" :interval="600000" height="400px">
						<el-carousel-item class="bannerItem" v-for="item in bannerList" :key="item.image">
							<el-image style="width: 100%; height: 100%" :src="item.image" fit="cover"></el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="box" v-if="subjectList.length">
					<div class="boxContent subject">
						<div class="item" v-for="item in subjectList" @click="toListWithSubj(item)" :key="item.id">
							<img v-if="item.image" :src="item.image" alt="" width="100%" height="100%" />
							<img v-else src="@/assets/placeholder.jpg" alt="" width="100%" height="100%" />
							<p class="pOne">{{item.subject_name}}<i class="el-icon-arrow-right"></i></p>
							<!-- <p class="pOne">立即学习</p> -->
						</div>
					</div>
				</div>
				<div class="box" v-if="courseData.zhuanti&&courseData.zhuanti.length">
					<div class="boxTitle">
						<p>精选专题</p>
						<p @click="toList('column')">更多<i class="el-icon-arrow-right"></i> </p>
					</div>
					<div class="boxContent course">
						<div class="item" v-for="item in courseData.zhuanti" @click="gotoDetail(item,'special')" :key="item.id">
							<p class="pTag">专栏</p>
							<img v-if="item.image" :src="item.image" alt="" width="100%" height="100%" />
							<img v-else src="@/assets/placeholder.jpg" alt="" width="100%" height="100%" />
							<p class="pOne">{{ item.name || '' }}</p>
							<p class="pTwo" v-if="item.remark">{{ item.remark || ''}}</p>
							<p class="pThere" v-if="item.price&&item.price*100==0">免费</p>
							<p class="pThere" v-else-if="item.price">￥{{ item.price }}</p>
							<p class="pThere" v-else></p>
						</div>
					</div>
				</div>
				<div class="box" v-if="courseData.jingpin&&courseData.jingpin.length">
					<div class="boxTitle">
						<p>精选课程</p>
						<p @click="toList('course')">更多<i class="el-icon-arrow-right"></i> </p>
					</div>
					<div class="boxContent course">
						<div class="item" v-for="item in courseData.jingpin" @click="gotoDetail(item,'course')" :key="item.id">
							<p class="pTag">课程</p>
							<img v-if="item.thumb_image" :src="item.thumb_image" alt="" width="100%" height="100%" />
							<img v-else src="@/assets/placeholder.jpg" alt="" width="100%" height="100%" />
							<p class="pOne">{{ item.title || '' }}</p>
							<p class="pTwo" v-if="item.description">{{ item.description || ''}}</p>
							<p class="pThere" v-if="item.price&&item.price*100==0">免费</p>
							<p class="pThere" v-else-if="item.price">￥{{ item.price }}</p>
							<p class="pThere" v-else></p>
						</div>
					</div>
				</div>
				<div class="box" v-if="courseData.mianfei&&courseData.mianfei.length">
					<div class="boxTitle">
						<p>免费小课</p>
					</div>
					<div class="boxContent course">
						<div class="item" v-for="item in courseData.mianfei" @click="gotoDetail(item,'course')" :key="item.id">
							<img v-if="item.thumb_image" :src="item.thumb_image" alt="" width="100%" height="100%" />
							<img v-else src="@/assets/placeholder.jpg" alt="" width="100%" height="100%" />
							<p class="pOne">{{ item.title || '' }}</p>
							<p class="pTwo" v-if="item.description">{{ item.description || '' }}</p>
							<p class="pThere" v-if="item.price&&item.price*100==0">免费</p>
							<p class="pThere" v-else-if="item.price">￥{{ item.price }}</p>
							<p class="pThere" v-else></p>
						</div>
					</div>
				</div>
				<div class="box">
					<div class="boxTitle">
						<p>语之乐优课</p>
					</div>
					<div class="boxContent category">
						<div class="item" v-for="item in navList" @click="clickItem(item)" :key="item.id">
							<img v-if="item.icon_image" :src="item.icon_image" alt="" width="100%" height="100%" />
							<img v-else src="@/assets/placeholder.jpg" width="100%" height="100%" />
							<p class="pOne">{{ item.name }}</p>
							<p class="pTwo">{{ item.remark }}</p>
						</div>
					</div>
				</div>
				<div class="box">
					<div class="boxTitle">
						<p>关于语之乐优课</p>
					</div>
					<div class="boxContent about">
						<img src="@/assets/home/about.png" alt="about" width="100%" height="100%" />
						<div class="txtContent">
							<p>
								语之乐是一家正规注册、取得相关资质，主要从事青少年写作教育研究与培训的艺术机构，经过二十多年的发展，现已研发系列课程三十级，共计上千节课。课程针对学习者，主要解决人文思想、文学思维、写作方法、文学积淀、文学作品阅读鉴赏及创作实践等方面遇到的问题。
							</p>
							<p>
								课程分为文学启蒙、文学基础、文学创作三大板块。文学启蒙一共七级，课程包括国学积累、人文思想训练、文学思维训练、看图写话训练、语感训练等内容，培养学习者联想力、想象力和表达能力；文学基础一共十六级，课程包括文学积累、人文思想训练、文学思维训练、景物（人物）细节描写、不同文学体裁（散文、小说、现代诗）文章的构篇方法、不同文学体裁文章的选材与主题提炼、表达的角度与创新；文学创作课程主要学习散文、小说与现代诗创作的常见方法，通过案例分析、仿写、实践的训练过程，引导初学文学创作者快速入门。
							</p>
							<p>
								针对青少年学生，本课程体系可以解决无法动笔、写不长、写不具体、写不生动、跑题偏题、没有条理、主题肤浅等问题，通过学习，可以将作文提升为作品。针对文学爱好者，学习本课程体系可以打好扎实的基本功，快速掌握各种文学体裁的特征，学习三大类文学体裁常见的创作方法与技巧，能够快速入门。
							</p>
							<p>
								针对中高考本机构开发的课程，主要是结合中、高考写作评分标准，有针对性的以解决实际问题为目的的训练体系。学习文学创作，能够帮助考生少走弯路，把作文变成作品，提升文章质量。
							</p>
							<h1>企业文化</h1>
							<p>学好写作、受益一生</p>
						</div>
					</div>
				</div>

				<div class="contact">
					<img class="bg" src="@/assets/home/contact.jpg" alt="contact" width="100%" height="100%" />
					<div class="us">
						<p>联系我们为您定制专属课程</p>
						<img class="qr" v-for="qr in erweimaList" :key="qr.id" :src="qr.image" alt="二维码" width="100%"
							height="100%" />
					</div>
					<div class="link">
						<p>友情链接</p>
						<ul>
							<li><a href="http://jyt.hubei.gov.cn" target="_blank">湖北省教育厅</a></li>
							<li><a href="http://www.e21.cn/" target="_blank">湖北教育信息网</a></li>
							<li><a href="http://www.enshi.gov.cn/" target="_blank">恩施州人民政府</a></li>
							<li><a href="https://www.news.cn/" target="_blank">新华网</a></li>
							<li><a href="https://www.sina.com.cn/" target="_blank">新浪网</a></li>
							<li><a href="https://www.163.com/" target="_blank">网易网</a></li>
							<li><a href="https://www.sohu.com/" target="_blank">搜狐</a></li>
							<li><a href="https://www.tencent.com/zh-cn/" target="_blank">腾讯</a></li>
							<li><a href="https://www.baidu.com/" target="_blank">百度一下</a></li>
							<li><a href="https://www.doubao.com/chat/" target="_blank">豆包</a></li>
							<li><a href="https://www.deepseek.com/" target="_blank">Deepseek</a></li>
							<li><a href="https://ad.yuzhileyouke.cn/home.php/index/login" target="_blank">语之乐管理平台</a></li>
						</ul>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>